import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'
import { useEltDataSettings } from 'legacy/lut/components/widgets/public/partner360/ELT/context/EltDataSettingsContext'
import { useMemo } from 'react'

import { InfoBlock, InfoBlockType } from 'cng-common/components/infoBlock'

export const ActualsValueTypeWarning = () => {
  const { dataSettings } = useEltDataSettings()
  const isShow = useMemo(() => {
    return Boolean(
      dataSettings.NetNdp && dataSettings.DisplayWarningForTypes?.includes(dataSettings.NetNdp)
    )
  }, [dataSettings.NetNdp, dataSettings.DisplayWarningForTypes])

  return (
    <RenderWhen condition={isShow}>
      <InfoBlock text={dataSettings.WarningKey} type={InfoBlockType.Warning} />
    </RenderWhen>
  )
}
